import { CachingServiceImpl, FAKE_TTL, LS_KEY_DEBUG, tvpilGetLocalCache } from '@kaltura-ott/tvpil';

import { AppParams } from './../app/app-params';

type AppSwitchEnvConfig = {
  endpoint: string;
  partnerId: number;
  applicationName: string;
};

export async function mergeConfigs(params: AppParams) {
  const cache = tvpilGetLocalCache();

  const data = (await cache.getItem(LS_KEY_DEBUG)) || {};

  Object.assign(params.dmsSetting, data);
}

export function clearDebugDataStorage(cacheService: CachingServiceImpl): void {
  cacheService.removeItem(LS_KEY_DEBUG);
}

export function setSwitchEnvParamsToStorage(data: AppSwitchEnvConfig) {
  const cache = tvpilGetLocalCache();

  cache.clear();

  cache.setItem(LS_KEY_DEBUG, data, FAKE_TTL);
}
